/**
 * Merge a collection store with a new collection of items
 * Preserves any items that are not in the new collection
 * @param {*} collectionStore
 * @param {*} newCollection
 */
export const mergeCollectionStore = (collectionStore, newCollection) => {
	collectionStore.update((oldItems) => {
		oldItems.map((item) => {
			if (newCollection.where('id', item.id).count() === 0) {
				newCollection.push(item);
			}
		});

		return newCollection;
	});
};

/**
 * Merge data object into existing Model for a Collection Store.
 * Expects data to be in same structure as existing model with model.id = data.id
 * @param {*} data
 * @param {*} collectionStore
 */
export const mergeModelDataInCollectionStore = (data, collectionStore) => {
	collectionStore.update((items) => {
		return items.each((item) => {
			try {
				if (item.id === String(data.id)) {
					delete data.id;
					// Sport data can come through in meta which should be treated as model properties
					item = data.meta ? Object.assign(item, data.meta) : Object.assign(item, data);
				}
			} catch (error) {
				console.error(error);
			}
			return item;
		});
	});
};
